// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerritorySelector {
  position: relative;
  background-color: var(--base_color2);
  padding: 0;
}
.TerritorySelector .compare-topic-input-group {
  display: flex;
  flex-direction: column;
}
.TerritorySelector .select-group .select-icon-group .filter > div {
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 4px;
}
.TerritorySelector .selected-elements-container {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  gap: 8px;
  gap: var(--spacing_unit_3, 8px);
}
.TerritorySelector .selected-elements-container > .ComparisonSelector-SelectedItems {
  margin: 0;
}
.TerritorySelector .selected-elements-container .content-warning {
  padding: 8px;
  border-radius: 4px;
  margin-top: 4px;
  margin-bottom: 10px;
}
.TerritorySelector .selected-elements-container .content-warning > p {
  font-size: 12px;
  line-height: 18px;
}
.TerritorySelector .selected-elements-container .content-warning > svg {
  width: 20px !important;
  height: 20px !important;
}
.TerritorySelector .compare-input-component {
  flex-grow: 1;
}
.TerritorySelector .compare-input-component .BlockClickTooltip {
  display: block;
  cursor: default;
}
.TerritorySelector .compare-input-component {
  z-index: 1;
}
.TerritorySelector .TerritorySelector-input-container {
  font-size: 14px;
}
.TerritorySelector .TerritorySelector-input-container .select-icon {
  position: absolute;
  z-index: 1;
  left: 0;
  display: block;
  fill: var(--gray_dark1);
  margin-left: 14px;
}
.TerritorySelector .TerritorySelector-input-container [class\$=-menu] {
  margin-top: 12px;
}
.TerritorySelector .TerritorySelector-input-container [class\$=-menu] > div {
  max-height: 440px;
}
.TerritorySelector .TerritorySelector-input-container [class\$=-menu] > div > div:first-child {
  margin-top: 30px;
}
.TerritorySelector .TerritorySelector-input-container [class\$=-menu] > div > div:last-child {
  margin-bottom: 30px;
}
.TerritorySelector .TerritorySelector-input-container [class\$=-placeholder] {
  color: var(--color_neutral_500);
}
.TerritorySelector .TerritorySelector-subtitle {
  font-size: 10px;
  color: var(--color_neutral_500);
  margin-top: var(--spacing_unit_1);
  margin-bottom: var(--spacing_unit_3);
}
.TerritorySelector .select-container {
  margin: 15px;
  flex: 1 1;
  display: flex;
}
.TerritorySelector .select-group .button-component {
  margin-left: 15px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardModals/CreateDashboardModal/components/TerritorySelector/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oCAAA;EACA,UAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;AAEE;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EAAA,+BAAA;AADJ;AAGI;EACE,SAAA;AADN;AAII;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAFN;AAIM;EACE,eAAA;EACA,iBAAA;AAFR;AAKM;EACE,sBAAA;EACA,uBAAA;AAHR;AAQE;EACE,YAAA;AANJ;AAQI;EACE,cAAA;EACA,eAAA;AANN;AACE;EAQE,UAAA;AANJ;AASE;EACE,eAAA;AAPJ;AASI;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AAPN;AAUI;EACE,gBAAA;AARN;AAUM;EACE,iBAAA;AARR;AAUQ;EACE,gBAAA;AARV;AAWQ;EACE,mBAAA;AATV;AAcI;EACE,+BAAA;AAZN;AAgBE;EACE,eAAA;EACA,+BAAA;EACA,iCAAA;EACA,oCAAA;AAdJ;AAiBE;EACE,YAAA;EACA,SAAA;EACA,aAAA;AAfJ;AAmBI;EACE,iBAAA;EACA,YAAA;AAjBN","sourcesContent":[".TerritorySelector {\n  position: relative;\n  background-color: var(--base_color2);\n  padding: 0;\n\n  .compare-topic-input-group {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .select-group .select-icon-group .filter > div {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-radius: 4px;\n  }\n\n  .selected-elements-container {\n    display: flex;\n    flex-grow: 1;\n    flex-wrap: wrap;\n    gap: var(--spacing_unit_3, 8px);\n\n    & > .ComparisonSelector-SelectedItems {\n      margin: 0;\n    }\n\n    .content-warning {\n      padding: 8px;\n      border-radius: 4px;\n      margin-top: 4px;\n      margin-bottom: 10px;\n\n      & > p {\n        font-size: 12px;\n        line-height: 18px;\n      }\n\n      & > svg {\n        width: 20px !important;\n        height: 20px !important;\n      }\n    }\n  }\n\n  .compare-input-component {\n    flex-grow: 1;\n\n    .BlockClickTooltip {\n      display: block;\n      cursor: default;\n    }\n\n    z-index: 1;\n  }\n\n  .TerritorySelector-input-container {\n    font-size: 14px;\n\n    .select-icon {\n      position: absolute;\n      z-index: 1;\n      left: 0;\n      display: block;\n      fill: var(--gray_dark1);\n      margin-left: 14px;\n    }\n\n    [class$='-menu'] {\n      margin-top: 12px;\n\n      > div {\n        max-height: 440px;\n\n        > div:first-child {\n          margin-top: 30px;\n        }\n\n        > div:last-child {\n          margin-bottom: 30px;\n        }\n      }\n    }\n\n    [class$='-placeholder'] {\n      color: var(--color_neutral_500);\n    }\n  }\n\n  .TerritorySelector-subtitle {\n    font-size: 10px;\n    color: var(--color_neutral_500);\n    margin-top: var(--spacing_unit_1);\n    margin-bottom: var(--spacing_unit_3);\n  }\n\n  .select-container {\n    margin: 15px;\n    flex: 1;\n    display: flex;\n  }\n\n  .select-group {\n    .button-component {\n      margin-left: 15px;\n      height: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
